module.exports = "/static/assets/c2073e853862dc92c79cd6ca2252c3f9.svg";